import React, { useEffect } from 'react';
import { Body, FormCadastro, Input, PageHeader, Spin, View, Field, GroupField, SubmitButton } from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import App from '@app';
import { getTemplateGrupo, reset, putTemplateGrupo, postTemplateGrupo } from '@ducks/conectoresTemplatesGrupos';

export default function TemplatesGruposCadastro() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const [form] = FormCadastro.useForm();
  const edicao = id !== '-1';

  const templateGrupo = useSelector(({ conectoresTemplatesGrupos }) => conectoresTemplatesGrupos.get('templateGrupo'));
  const loadingTemplateGrupo = useSelector(({ conectoresTemplatesGrupos }) => conectoresTemplatesGrupos.get('loadingTemplateGrupo'));
  const successTemplateGrupo = useSelector(({ conectoresTemplatesGrupos }) => conectoresTemplatesGrupos.get('successTemplateGrupo'));
  const successPutTemplateGrupo = useSelector(({ conectoresTemplatesGrupos }) => conectoresTemplatesGrupos.get('successPutTemplateGrupo'));
  const successPostTemplateGrupo = useSelector(({ conectoresTemplatesGrupos }) =>
    conectoresTemplatesGrupos.get('successPostTemplateGrupo')
  );

  const handleReset = () => dispatch(reset());

  useEffect(() => {
    if (edicao) {
      dispatch(getTemplateGrupo(id));
    }
  }, []);

  useEffect(() => {
    if (successPutTemplateGrupo || successPostTemplateGrupo) {
      handleReset();
      history.goBack();
    }
  }, [successPutTemplateGrupo, successPostTemplateGrupo]);

  useEffect(() => {
    if (templateGrupo && edicao) {
      form.setFieldsValue(templateGrupo);
    }
  }, [successTemplateGrupo]);

  function handleSubmit(data) {
    if (edicao) {
      data.id = id;
      dispatch(putTemplateGrupo(data));
    } else {
      dispatch(postTemplateGrupo(data));
    }
  }

  return (
    <App>
      <Body>
        <PageHeader title='Grupo de template' onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            {loadingTemplateGrupo ? (
              <Spin />
            ) : (
              <View>
                <GroupField>
                  <Field label='Descrição' name='ds' rules={[{ required: true, message: 'Informe a descrição' }]}>
                    <Input autoFocus />
                  </Field>
                </GroupField>

                <SubmitButton type='success' htmlType='submit' block>
                  Salvar
                </SubmitButton>
              </View>
            )}
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
